import React, { useEffect, useState } from "react";

import api from "../services/api";
import jwt_decode from "jwt-decode";
import { useParams, useHistory } from "react-router-dom";

import useWindowSize from "../hooks/useWindowSize";

import GradientGauge from "../components/modernGauge";

export default function Dashboard() {
  const { token } = useParams();
  const history = useHistory();

  const [radarDash, setRadarDash] = useState(null);
  const [radarLocation, setRadarLocation] = useState(null);
  const [imgLojaIsOpen, setImgLojaIsOpen] = useState(true);
  const [locationName, setLocationName] = useState("WindRadar");
  const [color, setColor] = useState("#2275FF");

  const REFRESH_TIMEOUT = 300000;
  const TOKEN_EXPIRATION = 900000;

  const { width, height } = useWindowSize();

  const styles = buildPanelStyles(width);

  const api_request = async () => {
    let id_location;
    let decoded;

    try {
      decoded = jwt_decode(token);
    } catch {
      decoded = null;
    }

    if (!decoded || decoded?.origin !== "dashboard") {
      console.log("Decoded", token);
      try {
        const resp = await api.get(`/location/?url_alias=${token}`, {
          headers: {
            authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
          },
        });

        if (!resp?.data?.[0]?.id) return history.push("/notfound");

        setRadarLocation(resp.data);
        setLocationName(
          `${resp.data[0].spot_name}, ${resp.data[0].beach.name}
         ${resp.data[0].beach.location.city.name}/${resp.data[0].beach.location.state.uf}`
        );

        id_location = resp.data[0].id;

        console.log("Decoded2", decoded);
      } catch (err) {
        console.log(err);
      }
    } else {
      const now = Date.now();
      const due =
        decoded.exp > decoded.iat
          ? decoded.exp
          : decoded.iat + TOKEN_EXPIRATION;

      if (due < now) return history.push("/expired");

      const resp = await api.get(`/location/?id_local=${decoded.id}`, {
        headers: {
          authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
        },
      });

      if (!resp?.data?.length) return history.push("/notfound");

      setRadarLocation(resp.data);
      setLocationName(
        `${resp.data[0].spot_name}, ${resp.data[0].beach.name}
         ${resp.data[0].beach.location.city.name}/${resp.data[0].beach.location.state.uf}`
      );

      id_location = decoded.id;
    }

    const dash = await api.get(`/v2/radar/dashboard/${id_location}`, {
      headers: {
        authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
      },
    });

    if (!dash?.data) return history.push("/notfound");

    setRadarDash(dash.data);
    setColor(dash.data?.instant_measure?.color || "#2275FF");
  };

  useEffect(() => {
    console.log("[Dashboard says]: ", token);
    if (!token) return history.push("/notfound");

    api_request();
    const i = setInterval(api_request, REFRESH_TIMEOUT);
    return () => clearInterval(i);
  }, [token]);

  if (!radarLocation || !radarDash) {
    return (
      <div style={styles.loading}>
        <span>Loading...</span>
      </div>
    );
  }

  const direction = radarDash.instant_measure?.degrees
    ? `${radarDash.instant_measure.cardeal} ${radarDash.instant_measure?.degrees}°`
    : "";

  return (
    <div style={styles.root}>
      <header style={styles.header}>
        <h2>WindRadar App</h2>
        <h1 style={styles.location}>{locationName}</h1>
        <h1 style={styles.now}>AGORA</h1>

        <GradientGauge
          size={(width * 15) / 100}
          value={radarDash.instant_measure.sustained}
          max={50}
          unit="Nós"
          direction={direction}
        />

        <div style={styles.info}>
          <h3>{radarDash.instant_measure.wind_alignment}</h3>
          <h4>
            Medição:{" "}
            {new Date(radarDash.instant_measure.last_measure).toLocaleString(
              "pt-BR"
            )}
          </h4>
          <h3>ÚLTIMA HORA</h3>
        </div>
        <div style={styles.boxes}>
          <Box
            color="#8ED000"
            value={radarDash.last_hour_cards?.sustained}
            label="Média"
          />
          <Box
            color="#D00000"
            value={radarDash.last_hour_cards?.gust}
            label="Rajada"
          />
        </div>
        <div style={styles.info}>
          <h3>Bons ventos!</h3>
        </div>
      </header>
    </div>
  );
}

/* ───────────────── STYLES ───────────────── */
function buildPanelStyles(width, fontSizeRatio = 1) {
  const fs = (w, ratio, min, max) =>
    Math.max(min, Math.min(w * ratio * fontSizeRatio, max));

  return {
    root: {
      width: "100%",
      height: "100vh", // 🔑 important
      overflowY: "auto",

      display: "flex", // 🔑
      alignItems: "center", // 🔑 vertical center
      justifyContent: "center", // 🔑 horizontal center

      padding: 10,
      paddingRight: 20,
      boxSizing: "border-box",
      fontFamily: "Montserrat",
      backgroundColor: "rgba(255, 255, 255, 0.85)",
    },

    header: {
      border: "1px solid gray",
      borderRadius: 8,
      padding: 10,
      marginBottom: 10,
      textAlign: "center",
    },

    /* ─────────────── FONTS (WIDTH BASED) ─────────────── */

    location: {
      fontSize: fs(width, 0.02, 14, 28), // ~2vw
      fontWeight: "bold",
    },

    now: {
      fontSize: fs(width, 0.04, 24, 56), // ~4vw
      margin: "5px 0",
      fontWeight: "bold",
    },

    info: {
      marginTop: 10,
      fontSize: fs(width, 0.014, 12, 20),
    },

    /* ─────────────── CONTENT ─────────────── */

    content: {
      alignItems: "center",
      border: "1px solid gray",
      borderRadius: 8,
      padding: 10,
    },

    boxes: {
      display: "flex",
      flexWrap: "wrap", // 🔑 allow wrapping
      gap: 10,
      marginTop: 10,
    },

    qr: {
      marginTop: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 10,
      fontSize: fs(width, 0.013, 12, 18),
    },

    qrImg: {
      width: Math.max(90, Math.min(width * 0.12, 140)),
      height: Math.max(90, Math.min(width * 0.12, 140)),
      borderRadius: 12,
    },

    loading: {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: fs(width, 0.016, 14, 24),
    },
  };
}

/* ──────────────── SMALL COMPONENT ─────────────── */

function Box({ color, value, label, footer }) {
  return (
    <div style={{ ...box.base, backgroundColor: color }}>
      <div style={box.value}>{value}</div>
      <div style={box.footer}>{footer || "Nós"}</div>
      <div style={box.label}>{label}</div>
    </div>
  );
}

const box = {
  base: {
    flex: "1 1 90px", // 🔑 responsive base width
    minWidth: 90, // 🔑 prevents text squeeze
    maxWidth: "100%", // 🔑 prevents overflow
    borderRadius: 8,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 8,
    boxSizing: "border-box",
  },

  value: {
    fontSize: "clamp(1.6rem, 3vw, 2.4rem)", // 🔑 responsive
    fontWeight: "bold",
    textAlign: "center",
    lineHeight: 1.1,
  },

  footer: {
    textAlign: "center",
    fontSize: "clamp(0.9rem, 2vw, 1.2rem)",
  },

  label: {
    backgroundColor: "rgba(0,0,0,0.3)",
    padding: 4,
    borderRadius: 6,
    textAlign: "center",
    fontSize: "clamp(0.9rem, 2vw, 1.2rem)",
  },
};
